import {
  ListItem,
  ListItemButton,
  ListItemButtonProps,
  ListItemIcon,
  ListItemIconProps,
  ListItemProps,
  ListItemText,
  ListItemTextProps,
  Box,
  BoxProps,
  styled,
} from "@mui/material";

interface TabPanelProps {
  children?: React.ReactNode;
  label: "global" | "admin";
  value: "global" | "admin";
  sx?: BoxProps["sx"];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  containerSx?: Record<string, any>;
}

export const activeSidebarColor = "#0d6b40";

export function CustomTabPanel(props: TabPanelProps) {
  const { children, value, label, containerSx = {}, ...other } = props;

  return (
    <Box role="tabpanel" hidden={value !== label} id={`sidebar-tabpanel-${label}`} aria-labelledby={`sidebar-tab-${label}`} {...other} sx={props.sx ? props.sx : undefined}>
      {value === label && (
        <Box
          sx={() => ({
            ...(containerSx || {}),
          })}
        >
          {children}
        </Box>
      )}
    </Box>
  );
}

export const CustomMenuListItem = styled(ListItem)<ListItemProps>(({ theme }) => ({
  cursor: "pointer",
  color: "rgba(255, 255, 255, 0.8)",
  display: "flex",
  justifyContent: "space-between",
  borderRadius: "12px",
  padding: `${theme.spacing(2)} ${theme.spacing(2.5)}`,
  "&:hover": {
    backgroundColor: "rgba(13, 107, 64, 0.5)",
  },
  [theme.breakpoints.down("md")]: {
    padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
  },
}));

export const CustomListItem = styled(ListItemButton)<ListItemButtonProps>(({ theme }) => ({
  cursor: "pointer",
  color: "rgba(255, 255, 255, 0.8)",
  borderRadius: "12px",
  padding: `${theme.spacing(2)} ${theme.spacing(2.5)}`,
  "&:hover": {
    backgroundColor: "rgba(13, 107, 64, 0.5)",
  },
  '&[data-active="true"]': {
    backgroundColor: activeSidebarColor,
    color: "#ecf2f9",
    borderRadius: "12px",
    fontWeight: "bold",
  },
  '&[data-active="true"] .MuiListItemIcon-root': {
    color: "#ecf2f9",
  },
  [theme.breakpoints.down("md")]: {
    padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
  },
}));

export const CustomListItemIcon = styled(ListItemIcon)<ListItemIconProps>(() => ({
  minWidth: "35px",
}));

export const CustomListItemText = styled(ListItemText)<ListItemTextProps>(({ theme }) => ({
  flex: "none",
  color: "inherit",
  fontWeight: "inherit",
  "& span": {
    color: "inherit",
    fontWeight: "inherit",
    fontSize: "inherit",
  },
  [theme.breakpoints.down("md")]: {
    fontSize: "0.875rem",
  },
}));

export const Main = styled(Box)<BoxProps>(() => ({
  display: "flex",
  height: "100vh",
  position: "fixed",
  zIndex: 1001,
  boxShadow: "0px 0px 10px 0px rgb(0 0 0 / 30%)",
}));

export const Logo = styled("img")(({ theme }) => ({
  // width: "100%",
  maxWidth: "300px",
  backgroundColor: theme.palette.primary.main,
}));
